var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    attrs: {
      title: "认证详情",
      visible: _vm.innerVisible,
      width: "850px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.innerVisible = $event;
      }
    }
  }, [_c("el-descriptions", {
    attrs: {
      column: 1,
      border: ""
    }
  }, [_c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_vm._v("认证名称")]), _vm._v(" " + _vm._s(_vm.detail.certificationName || _vm.detail.companyName) + " ")], 2), _c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_vm._v("认证唯一编码")]), _vm._v(" " + _vm._s(_vm.detail.authNo) + " ")], 2), _c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_vm._v("认证类型")]), _vm.detail.certificationType == "company" ? _c("span", [_vm._v("营业执照")]) : _vm.detail.certificationType == "personal" ? _c("span", [_vm._v("身份证")]) : _vm._e()], 2), _c("el-descriptions-item", [_c("template", {
    slot: "label"
  }, [_vm._v(_vm._s(_vm.detail.certificationType == "company" ? "营业执照" : "身份证"))]), _vm._l(_vm.detail.urls, function (url, index) {
    return _c("wlc-image", {
      key: index,
      attrs: {
        current: index,
        list: _vm.detail.urls,
        src: url
      }
    });
  })], 2)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };